export default "<section id=\"report\" #reportContainer>\r\n  <!-- <div style=\"width: 100%; height: 100%\" #reportContainer></div>  -->\r\n</section>";